// PropGo is only provisioned for these tenants on the backend; every other
// tenant gets a 422, so the UI is hidden entirely for them (there is no
// "is it enabled" endpoint — the slug is the only gate available).
export const PROPGO_ENABLED_TENANT_SLUGS = [
  "bayut-ksa",
  "zameen-development",
  "training",
];

export const isPropGoEnabledForTenant = (slug) =>
  PROPGO_ENABLED_TENANT_SLUGS.includes(slug);
